/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserNotificationSettingsDto } from '../../models/user-notification-settings-dto';

export interface UserControllerUpdateNotificationSettings$Params {
      body: UserNotificationSettingsDto
}

export function userControllerUpdateNotificationSettings(http: HttpClient, rootUrl: string, params: UserControllerUpdateNotificationSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<UserNotificationSettingsDto>> {
  const rb = new RequestBuilder(rootUrl, userControllerUpdateNotificationSettings.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserNotificationSettingsDto>;
    })
  );
}

userControllerUpdateNotificationSettings.PATH = '/api/user/me/notification-settings';
